import { Dialog, DialogContent } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { aud, auDate, BACKEND_URL } from "../lib/api";

const LAYOUT = { title: "TAX INVOICE", logo_position: "left", accent: "#C2A462", show_phone: true, show_email: true, show_address: true, terms: "", notes: "", show_period: true, show_qty: true };

function Payment({ inv }) {
  if (inv.payment_method === "bank") {
    const b = inv.bank || {};
    return (
      <div className="rounded border border-slate-200 p-3 text-sm" data-testid="invoice-payment-bank">
        <div className="font-semibold">Payment by bank transfer · due within {inv.payment_terms_days} days</div>
        <div>Account name: {b.bank_account_name || "[Add in Enterprise Details]"}</div>
        <div>BSB: {b.bank_bsb || "—"} · Account: {b.bank_account_number || "—"}</div>
        <div>Reference: {inv.number}</div>
      </div>
    );
  }
  if (inv.payment_method === "card") return <div className="text-sm text-slate-600" data-testid="invoice-payment-card">Payment by credit card on file.</div>;
  return null;
}

export function InvoiceDoc({ inv }) {
  const L = { ...LAYOUT, ...(inv.layout || {}) };
  const items = inv.items?.length ? inv.items : [{ description: inv.description, qty: 1, unit_price: inv.subtotal, amount: inv.subtotal }];
  const bill = [inv.billing_name, inv.billing_email, inv.billing_phone, inv.billing_address].filter(Boolean);
  const logo = inv.logo && <img src={`${BACKEND_URL}${inv.logo}`} alt="Logo" className="h-14 w-auto object-contain" data-testid="invoice-logo" />;
  const pos = { left: "justify-start", centre: "justify-center", right: "justify-end" }[L.logo_position];
  return (
    <div id="print-invoice" className="space-y-6 p-2" style={{ "--accent": L.accent }} data-testid="invoice-doc">
      {logo && L.logo_position !== "left" && <div className={`flex ${pos}`}>{logo}</div>}
      <div className="flex justify-between gap-4">
        <div>
          {L.logo_position === "left" && logo && <div className="mb-3">{logo}</div>}
          <div className="text-2xl font-extrabold font-display" style={{ color: L.accent }} data-testid="invoice-title">{L.title}</div>
          <div className="text-sm font-mono" data-testid="invoice-number">{inv.number}</div>
        </div>
        <div className="text-right text-sm">
          <div className="font-semibold">{inv.supplier_name}</div>
          <div>ABN: {inv.supplier_abn || "[Add ABN in Enterprise Details]"}</div>
          {L.show_address && inv.supplier_address && <div>{inv.supplier_address}</div>}
          {L.show_email && inv.supplier_email && <div>{inv.supplier_email}</div>}
          {L.show_phone && inv.supplier_phone && <div>{inv.supplier_phone}</div>}
        </div>
      </div>
      <div className="grid grid-cols-2 text-sm">
        <div data-testid="invoice-bill-to"><div className="text-xs uppercase text-slate-500">Bill to</div><div className="font-semibold">{inv.account_name}</div>{inv.account_abn && <div>ABN: {inv.account_abn}</div>}{bill.map((l) => <div key={l}>{l}</div>)}</div>
        <div className="text-right"><div>Issued: {auDate(inv.issue_date)}</div><div>Due: {auDate(inv.due_date)}</div><div className="uppercase font-semibold">{inv.status}</div></div>
      </div>
      <table className="w-full text-sm" data-testid="invoice-items">
        <thead><tr className="border-b-2 text-left" style={{ borderColor: L.accent }}><th className="py-2">Description</th>{L.show_period && <th>Period</th>}{L.show_qty && <th className="text-right">Qty</th>}{L.show_qty && <th className="text-right">Unit price</th>}<th className="text-right">Amount (AUD)</th></tr></thead>
        <tbody>{items.map((it, i) => (
          <tr key={i} className="border-b"><td className="py-2">{it.description}</td>{L.show_period && <td>{it.period || ""}</td>}{L.show_qty && <td className="text-right">{it.qty}{it.unit ? ` ${it.unit}` : ""}</td>}{L.show_qty && <td className="text-right">{aud(it.unit_price)}</td>}<td className="text-right">{aud(it.amount ?? it.qty * it.unit_price)}</td></tr>
        ))}</tbody>
      </table>
      <div className="ml-auto w-60 text-sm space-y-1">
        <div className="flex justify-between"><span>Subtotal</span><span>{aud(inv.subtotal)}</span></div>
        <div className="flex justify-between"><span>GST (10%)</span><span>{aud(inv.gst)}</span></div>
        <div className="flex justify-between font-bold border-t pt-1"><span>Total inc GST</span><span>{aud(inv.total)}</span></div>
      </div>
      <Payment inv={inv} />
      {L.notes && <div className="text-sm whitespace-pre-line" data-testid="invoice-notes">{L.notes}</div>}
      {L.terms && <div className="border-t pt-3 text-xs text-slate-600 whitespace-pre-line" data-testid="invoice-terms"><div className="font-semibold uppercase text-slate-500 mb-1">Terms & conditions of payment</div>{L.terms}</div>}
    </div>
  );
}

export function InvoiceView({ inv, onClose }) {
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl bg-white text-slate-900 max-h-[90vh] overflow-y-auto" data-testid="invoice-view">
        <InvoiceDoc inv={inv} />
        <Button onClick={() => window.print()} data-testid="print-invoice-btn">Print / Save PDF</Button>
      </DialogContent>
    </Dialog>
  );
}
